import React, { useEffect, useRef, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;

function ItemSucursal(props) {
    const {sucursal,idProducto,actualizar,proyeccion,callback} = props;
    const [error,setError] = useState({});
    const [productos,setProductos] = useState({});
    const [ventas,setVentas] = useState({});
    const [info,setInfo] = useState({});
    const [infoM,setInfoM] =useState(null);
    const [infoC,setInfoC] = useState(null);
    const [action,setAction] = useState(false);
    const hayDato = useRef();
    hayDato.current=action;
    function getInfoProyeccion(){
        var pr = proyeccion.filter((item)=>item.ID_SUCURSAL==sucursal.ID_SUCURSAL&&item.TIPO_PRODUCTO==idProducto);
        if(pr.length==0){
            return 0
        }else{
            return pr[0].TOTAL
        }
    }
    function getValor(){}

    function getInformacionPollo() {
        setAction(false);
        fetch(`${server}/reporte/getMovimientoPollo`, {
            cache:'no-store',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...sucursal
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok && data.ok.estadoInvInicial && data.ok.productos) {//10-11-12-13  14,15//PIPOCAS 137,134
                    console.log(data.ok)
                    setProductos(data.ok)
                    if(['N'].includes(data.ok.estadoInvInicial)==true){
                        setError({error:"?"})
                    }else{
                        var idP=0;
                        if(idProducto=='POLLO'){
                            idP=-3;//[10,11,12,13,14,15]
                            setInfoC(data.ok.productos.filter((dt)=>[2,3,4,5].indexOf(parseInt(dt.id_producto))!=-1))
                            setInfoM(data.ok.productos.filter((dt)=>[6,7,8,9].indexOf(parseInt(dt.id_producto))!=-1))
                        }else{
                            idP=187;//[187,134]
                            var aux=data.ok.productos.filter((dt)=>[134].indexOf(parseInt(dt.id_producto))!=-1)[0];
                            setInfoC(data.ok.productos.filter((dt)=>[920].indexOf(parseInt(dt.id_producto))!=-1));
                            setInfoM(null);
                            setVentas(aux)
                        }
                        var mostrar = data.ok.productos.filter((dt)=>dt.id_producto==parseInt(idP));//data.ok.productos.filter((dt)=>idP.indexOf(parseInt(dt.id_producto))!=-1)
                        setInfo(mostrar[0]);  
                        if(sucursal.ID_SUCURSAL==21){
                            console.log(mostrar);
                        }
                    }
                    setAction(true);
                } else {
                    setError({error:'ERR'})
                }
                callback();
            })
            .catch(error => MsgUtils.msgError(error));
    }

    function getInfoInicial(tipo){
        if(tipo=='C'){
            if(infoC.length!=0){
                var datos = infoC.map((item)=>item.inicial)
                var total = datos.reduce((a, b) => a + b, 0);
                return idProducto=='POLLO'?(total/100).toFixed(2):(total).toFixed(0);
            }
            return 0
        }else{
            if(infoM.length!=0){
                var datos = infoM.map((item)=>item.inicial)
                var total = datos.reduce((a, b) => a + b, 0);
                return (total/100).toFixed(2)
            }
            return 0
        }
    }

    useEffect(()=>{
        getInformacionPollo();
    },[idProducto,actualizar])
    return (
        <tr >
            <th scope="row">{sucursal.SUCURSAL}</th>
            <td className='text-center' style={{fontSize:'19px'}}><span className='badge rounded-pill btnActivo'>{getInfoProyeccion()}</span></td>
            {error.error==undefined&&hayDato.current==true&&<td className='text-center'>{idProducto=='POLLO'?((info.inicial/100)>=0?(info.inicial/100):'?'):(info.inicial+parseInt(getInfoInicial('C')))>=0?(info.inicial+parseInt(getInfoInicial('C'))):'?'}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
            {error.error==undefined&&idProducto=='PIPOC'&&<td className='text-center'>{info.inicial>=0?info.inicial:'?'}</td>}
            {error.error!==undefined&&idProducto=='PIPOC'&&<td className='text-danger text-center'>{error.error}</td>}

            {error.error==undefined&&infoC!=null&&<td className='text-center'>{idProducto=='POLLO'?getInfoInicial('C'):infoC[0].ingresos}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
            {error.error==undefined&&infoM!=null&&<td className='text-center'>{getInfoInicial('M')>=0?getInfoInicial('M'):'?'}</td>}
            {error.error!==undefined&&idProducto=='POLLO'&&<td className='text-danger text-center'>{error.error}</td>}

            {error.error==undefined&&hayDato.current==true&&<td className='text-center'>{idProducto=='POLLO'?(info.ingresos/100).toFixed(2):info.ingresos+infoC[0].ingresos}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
            {error.error==undefined&&hayDato.current==true&&<td className='text-center'>{idProducto=='POLLO'?(info.transito/100).toFixed(2):info.transito}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
            {error.error==undefined&&hayDato.current==true&&<td className='text-center'>{idProducto=='POLLO'?(info.egresos/100).toFixed(2):info.egresos+infoC[0].egresos}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
            {error.error==undefined&&hayDato.current==true&&<td className='text-center'>{idProducto=='POLLO'?(info.reservas/100).toFixed(2):ventas.reservas}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
            {error.error==undefined&&hayDato.current==true&&<td className='text-center'>{idProducto=='POLLO'?(info.vendido/100).toFixed(2):ventas.vendido}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
            {error.error==undefined&&hayDato.current==true&&
                <td className='text-center'>
                    {idProducto=='POLLO'?(((info.inicial>=0?info.inicial:0)+info.ingresos-info.egresos-info.reservas-info.vendido)/100).toFixed(2):
                    ((info.inicial>=0?info.inicial:0)+parseInt(getInfoInicial('C'))+info.ingresos+infoC[0].ingresos-infoC[0].egresos-info.egresos-ventas.vendido-ventas.reservas)}</td>}
            {error.error!==undefined&&<td className='text-danger text-center'>{error.error}</td>}
        </tr>
    )
}
export default ItemSucursal